// This icon file is generated automatically.
var PLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M9.31 1.41V.21c0-.11-.12-.17-.2-.1L2.07 5.6a.5.5 0 000 .78l7.04 5.5c.08.07.2.01.2-.1v-1.2a.25.25 0 00-.1-.2L3.6 6l5.63-4.4c.06-.04.1-.11.1-.19z", "fill-rule": "nonzero" } }] }, "name": "p-left", "theme": "outlined" };
export default PLeftOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PLeftOutlined.js
// module id = 3485
// module chunks = 0